import React, { createContext, useContext, ReactNode } from 'react';
import { AppInfoCandyRack } from '../shared/types';
import { getIntelligemsEnabledStatus } from '../shared/product-page-placement/intelligemsUtils';

const AppsInfoContext = createContext<AppInfoCandyRack | undefined>(undefined);

export const AppsInfoProvider = ({
  appsInfo,
  children,
}: {
  appsInfo: AppInfoCandyRack;
  children: ReactNode;
}) => {
  const isIntelligemsEnabled = getIntelligemsEnabledStatus(
    appsInfo.is_intelligems_enabled,
  );

  const info: AppInfoCandyRack = {
    ...appsInfo,
    is_intelligems_enabled: isIntelligemsEnabled,
  };

  return (
    <AppsInfoContext.Provider value={info}>{children}</AppsInfoContext.Provider>
  );
};

export function useAppsInfo(): AppInfoCandyRack {
  const context = useContext(AppsInfoContext);
  if (!context) {
    throw new Error('useAppsInfo must be used within an AppsInfoProvider');
  }
  return context;
}
